import { Directive, OnInit } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';

// Prevents PrimeNG dropdown panels from causing layout shifts by floating them above the DOM
@Directive({ selector: 'p-dropdown' })
export class DropdownAppendToBodyDirective implements OnInit {

  constructor(private dropdown: Dropdown) {}

  ngOnInit(): void {
    const hostElement = this.dropdown.el?.nativeElement as HTMLElement | null;
    const isInsideBootstrapModal = !!hostElement?.closest('ngb-modal-window, .modal');

    // Keeping the panel inside the modal avoids focus/backdrop lock issues in ng-bootstrap modals.
    if (isInsideBootstrapModal) {
      return;
    }

    if (!this.dropdown.appendTo) {
      this.dropdown.appendTo = 'body';
    }
  }

}
